export default {
    getItems: state => {
        return state.items;
    },
    current: (state, getters, rootState, rootGetters) => {
        const all = rootGetters['backpack/getItems']
        return all.filter(i => i.type == 'weapon');
    },
}